import { render, staticRenderFns } from "./TeamRecognition.vue?vue&type=template&id=ae7766d6&scoped=true"
import script from "./TeamRecognition.vue?vue&type=script&lang=js"
export * from "./TeamRecognition.vue?vue&type=script&lang=js"
import style0 from "./TeamRecognition.vue?vue&type=style&index=0&id=ae7766d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7766d6",
  null
  
)

export default component.exports